import axiosHttp from "services/axiosHttp";

// Release Service Functions
export const releaseService = {
  // Create release
  createRelease: async (data) => {
    const response = await axiosHttp.post("/pmo/release", data);
    return response.data;
  },

  // Get release list with optional params
  getReleaseList: async (params = {}) => {
    const response = await axiosHttp.get("/pmo/release", { params });
    return response.data;
  },

  // Get single release by ID
  getRelease: async (id) => {
    const response = await axiosHttp.get(`/pmo/release/${id}`);
    return response.data;
  },

  // Update release
  updateRelease: async (id, data) => {
    const response = await axiosHttp.put(`/pmo/release/${id}`, data);
    return response.data;
  },

  // Delete release
  deleteRelease: async (id) => {
    const response = await axiosHttp.post(`/pmo/release-delete/${id}`);
    return response.data;
  },

  // Add tasks to release
  addTasksToRelease: async (data) => {
    const response = await axiosHttp.post(`/pmo/release/${data.id}/tasks`, data);
    return response.data;
  },

  // Remove tasks from release
  removeTasksFromRelease: async (data) => {
    const response = await axiosHttp.delete(`/pmo/release/${data.id}/tasks`, { data });
    return response.data;
  }
};
